import { inlineJsonMarker } from './inlineJsonMarker'

export const EMAIL_DRAFT_FEEDBACK_CARD_MARKER = '__EMAIL_DRAFT_FEEDBACK_CARD__'

export interface EmailDraftFeedbackOption {
  label: string
  request?: string
  description?: string
}

export interface EmailDraftFeedbackQuestion {
  id?: string
  question: string
  options: EmailDraftFeedbackOption[]
}

export interface EmailDraftFeedbackPayload {
  draft_id?: string
  subject?: string
  title?: string
  questions?: EmailDraftFeedbackQuestion[]
  quick_options?: EmailDraftFeedbackOption[]
}

const emailDraftFeedbackCardMarker = inlineJsonMarker<EmailDraftFeedbackPayload>(
  EMAIL_DRAFT_FEEDBACK_CARD_MARKER,
)

export const parseEmailDraftFeedbackCard = emailDraftFeedbackCardMarker.parse
export const splitEmailDraftFeedbackCard = emailDraftFeedbackCardMarker.split
